module.exports = __webpack_public_path__ + "img/fundu.fcb3c7c.png";